{
    const table = document.querySelector('.js-conditions-table');
    const button = document.querySelector('.js-conditions-btn');

    button.addEventListener('click', function () {
        this.classList.toggle('conditions__btn_active');
        table.classList.toggle('conditions__table_active');

        this.textContent = this.classList.contains('conditions__btn_active')
                ? m.trans.get('View less')
                : m.trans.get('View more');
    });
}